import BuyFundAssestsTable from "./BuyFundAssestsTable";
import FundInvestmentsTable from "./FundInvestmentsTable";
import FundUnitsTable from "./FundUnitsTable";
import FundProviderTable from "./FundProviderTable";
import SalesTable from "./SalesTable";
import salesAndBalanceTable from "./salesAndBalanceTable";
import SalesTable2 from "./SalesTable2";
import SalesTable3 from "./SalesTable3";
import AdminProfileTable from "./adminProfileTable";
import ProviderApprovalRequestTable from "./ProviderApprovalRequestTable";
import providerProfileTable from "./providerProfileTable";
import YourDataUnitTable from "./YourDataUnitTable";
import AllFundSubscribersTable from "./AllFundSubscribersTable";
import AdminFundSubscriberTable from "./AdminFundSubscriberTable";
import FundSubscriberProfileTable from "./FundSubscriberProfileTable";
import DataConsumerDetailsTable from "./DataConsumerDetailsTable";
import DataTransactionTable from "./DataTransaction";
import PermissionsDetailTable from "./PermissionsDetailTable";
import PurchasedDataUnit_DetailsTable from "./PurchasedDataUnit_DetailsTable";

const Table = {
  BuyFundAssestsTable,
  FundInvestmentsTable,
  FundUnitsTable,
  FundProviderTable,
  SalesTable,
  SalesTable2,
  SalesTable3,
  salesAndBalanceTable,
  AdminProfileTable,
  ProviderApprovalRequestTable,
  providerProfileTable,
  YourDataUnitTable,
  AllFundSubscribersTable,
  AdminFundSubscriberTable,
  FundSubscriberProfileTable,
  DataConsumerDetailsTable,
  DataTransactionTable,
  PermissionsDetailTable,
  PurchasedDataUnit_DetailsTable,
};
export default Table;
